import {inject, LOCALE_ID, NgModule} from '@angular/core';
import {HashLocationStrategy, LocationStrategy, registerLocaleData} from '@angular/common';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {AppLayoutModule} from './layout/app.layout.module';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {authInterceptor} from './shared/interceptors/auth.interceptor';
import localeIt from '@angular/common/locales/it';
import localeEn from '@angular/common/locales/en';
import {Settings} from 'luxon';
import {environment} from '../environments/environment';
import {META_REDUCERS, Store} from '@ngrx/store';
import {storageMetaReducer} from './store/storage.meta-reducer';
import * as HydrationActions from './store/storage.actions';
import {httpErrorInterceptor} from './shared/interceptors/http-error.interceptor';
import {providePrimeNG} from 'primeng/config';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import Aura from '@primeng/themes/aura';
import {initializeApp, provideFirebaseApp} from '@angular/fire/app';
import {getMessaging, provideMessaging} from '@angular/fire/messaging';
import {LoggerService} from './shared/services/logger.service';
import {AppStoreModule} from "./app-store.module";
import {provideAuthSession} from './auth/auth.providers';
import {provideLayoutTheme, providePage} from './layout/layout.providers';
import {provideThemePreference} from './store/theme-preference.providers';

// Register locale data for all supported locales
registerLocaleData(localeIt);
registerLocaleData(localeEn);

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppStoreModule,
    AppLayoutModule,
    FontAwesomeModule,
    AppRoutingModule, // <--- must be the last
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: META_REDUCERS,
      multi: true,
      deps: [LoggerService],
      useFactory: (logger: LoggerService) => storageMetaReducer(logger),
    },
    providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } }),
    provideAuthSession(),
    providePage(),
    provideLayoutTheme(),
    provideThemePreference(),
    provideHttpClient(withInterceptors([authInterceptor, httpErrorInterceptor])),
    provideFirebaseApp(() => initializeApp(environment.firebase.options)),
    provideMessaging(() => getMessaging()),
  ],
  bootstrap: [AppComponent],
  exports: []
})
export class AppModule {
  private store = inject(Store);
  private locale = inject(LOCALE_ID);

  constructor() {
    Settings.defaultLocale = this.locale;
    Settings.defaultZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.store.dispatch(HydrationActions.hydrate());
  }
}
